import React, { Fragment, Component } from 'react';
import authService from '../../services/AuthService';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

class AccountProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mfaEnabled: false,
            mfaChangeSignature: null,
            mfaChangeReason: null,
            currentPassword: null,
            newPassword: null,
            confirmPassword: null,
            pwChangeMessage: this.props.pwChangeMessage
        }

        this.shouldSave = false;
    }

    pwChangeHandler = (e) => {
        this.state[e.target.id] = e.target.value;
        this.shouldSave = true;
    }

    pwSubmitChangeHandler = () => {
        if (!this.shouldSave) {
            return;
        }

        if (!this.verifyPwInfo()) {
            return;
        }

        let url = "/account/pwChange";
        api.post(url, 
        {
            userId: this.props.userId,
            accessToken: authService.authenticatedUserAccessToken,
            currentPassword: this.state.currentPassword,
            newPassword: this.state.newPassword
        },
        {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.setState({ currentPassword: "", newPassword: "", confirmPassword: "", pwChangeMessage: "Password successfully changed" });
                this.shouldSave = false;
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
            }
        })
        .catch((error) => {
            apiErrorPopup(apiErrorHandler(error));
            return;
        });
    }

    verifyPwInfo = () => {
        if (isNullOrEmpty(this.state.currentPassword)) {
            alertPopup('warning', "You must specify your current password in order to change to a new one.");
            return false;
        }

        if (isNullOrEmpty(this.state.newPassword) || this.state.newPassword.length < 8) {
            alertPopup('warning', "Passwords must be a minimum of 8 characters with at least one number and one special character");
            return false;
        }

        if (this.state.newPassword != this.state.confirmPassword) {
            alertPopup('warning', "Your confirm password does not match your new password.  Please re-enter and try again.");
            return false;
        }

        return true;
    }

    componentDidMount() {

        // Run a query and get the current user info.
        let url = "account/" + this.props.userId;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then(response => {
                if (response.status == 200) {

                    // Just bind the pertinent info.
                    this.setState({
                        mfaEnabled: response.data.mfaEnabled,
                        mfaChangeReason: response.data.mfaChangeReason,
                        mfaChangeSignature: response.data.mfaChangeSignature
                    })
                }
                else {
                    // Major problem - should not happen.  Back to login
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login
                apiErrorPopup(apiErrorHandler(error));
                authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
            });
    }

    mfaCheckboxHandler = (e) => {
        this.setState({ mfaEnabled: e.target.checked });
        this.shouldSave = true;
    }

    mfaHandler = (e) => {
        this.state[e.target.id] = e.target.value;
        this.shouldSave = true;
    }

    saveHandler = (e) => {
        if (this.shouldSave) {
            let url = "/account/" + this.props.userId + "/account";
            api.post(url,
                {
                    Id: this.props.userId,
                    accessToken: authService.authenticatedUserAccessToken,
                    mfaEnabled: this.state.mfaEnabled,
                    mfaChangeReason: this.state.mfaChangeReason,
                    mfaChangeSignature: this.state.mfaChangeSignature
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + authService.token
                    }
                })
                .then((response) => {
                    if (response.status != 200) {
                        apiErrorPopup(apiResponseHandler(response));
                    };
                    this.hasChanged = false;
                })
                .catch((error) => {
                    // Major problem!
                    apiErrorPopup(apiErrorHandler(error));
                    return;
                });
        }
    }

    render() {
        
        return (
            <Card onMouseLeave={this.saveHandler}>
                <Container>
                    <Form>
                        <h4 className="profile_GenInfoHdr">Login Information</h4>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Row>
                                <Col sm={1}>
                                    <Form.Label>CADE ID</Form.Label>
                                </Col>
                                <Col sm={11}>
                                    <Form.Label>{this.props.userId}</Form.Label>

                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Row>
                                <Col sm={1}>
                                    <Form.Label>Username</Form.Label>
                                </Col>
                                <Col sm={11}>
                                    <Form.Label>{this.props.userName}</Form.Label>
                                </Col>
                            </Row>
                        </Form.Group>

                        <h4 className="profile_GenInfoHdr">Change Password</h4>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>Current Password</Form.Label>
                            <Form.Control id="currentPassword" onChange={this.pwChangeHandler} type="password" value={this.state.currentPassword} placeholder="Required if you are entering a new password" />
                        </Form.Group>

                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>New Password</Form.Label>
                            <Form.Control id="newPassword" onChange={this.pwChangeHandler} type="password" value={this.state.newPassword} placeholder="8 character minimum with at least one number and one special character" />
                        </Form.Group>

                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>Confirm New Password</Form.Label>
                            <Form.Control id="confirmPassword" onChange={this.pwChangeHandler} type="password" value={this.state.confirmPassword} placeholder="Re-type your new password" />
                        </Form.Group>

                        <Button onClick={this.pwSubmitChangeHandler} variant="primary">Change Password</Button>
                        <p className="profile_pwChangeMessage">{this.state.pwChangeMessage}</p>

                        <h4 className="profile_GenInfoHdr">2 Factor Authentication</h4>
                        <p>
                            2 Factor authentication is an advanced security feature used to protect your account from access by unauthorized users.
                        </p>
                        <p>
                            When enabled, in addition to your normal login credentials, 2 factor authentication will also text your cell phone with a code.  Upon successful entry of that code, you will then be allowed into CADE.
                            2 factor authentication will happen only once or only very rarely such as when you login from a different computer.  So, in typical situations, you will not have to do a 2-step login process.
                        </p>
                        <p>
                            <b>Clear Child strongly recommends that you enable 2 factor authentication for your protection.</b>
                        </p>
                        <p>
                            If you want to opt-out of 2 factor authentication, please un-check the box below, provide a reason why you are disabling it and your name.
                            Conversely, if you previously opted-out and want to re-enable it, check the box, provider a reason and a signature.
                        </p>
                        <Fragment>

                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Check id="mfaCheckbox" onClick={this.mfaCheckboxHandler} checked = { this.state.mfaEnabled } type="checkbox" inline
                                    label="Enable 2 Factor Authentication"
                                />
                            </Form.Group>

                            <Form.Group controlId="exampleForm.ControlInput2">
                                <Form.Label>Reason for Change</Form.Label>
                                <Form.Control id="mfaChangeReason" onKeyUp={this.mfaHandler} type="text" value={this.state.mfaChangeReason} placeholder="Reason you are changing your 2FA preference" />
                            </Form.Group>

                            <Form.Group controlId="exampleForm.ControlInput3">
                                <Form.Label>Authorized Name</Form.Label>
                                <Form.Control id="mfaChangeSignature" onKeyUp={this.mfaHandler} type="text" value={this.state.mfaChangeSignature} placeholder="Full name of the person changing 2FA" />
                            </Form.Group>

                        </Fragment>
                    </Form>
                </Container>
            </Card>
        )
    }
}

export default AccountProfile;


// WEBPACK FOOTER //
// ./src/components/Profile/AccountProfile.js